import * as React from 'react'
import { cva, type VariantProps } from 'class-variance-authority'
import { cn } from '@/lib/utils'

const badgeVariants = cva(
  'inline-flex items-center rounded-md px-2.5 py-0.5 text-xs font-medium transition-colors',
  {
    variants: {
      variant: {
        default: 'bg-warm-800 text-white',
        secondary: 'bg-warm-100 text-text-secondary',
        outline: 'border border-border text-text-secondary',
        destructive: 'bg-red-100 text-red-700 border border-red-200',
        core: 'bg-core/10 text-core border border-core/20',
        market: 'bg-market/10 text-market border border-market/20',
        business: 'bg-business/10 text-business border border-business/20',
        solution: 'bg-solution/10 text-solution border border-solution/20',
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  }
)

export interface BadgeProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, ...props }: BadgeProps) {
  return <div className={cn(badgeVariants({ variant }), className)} {...props} />
}

export { Badge, badgeVariants }
